import { Pipe, PipeTransform } from '@angular/core';
import { OTVerbStemToEnglish } from '@models/HebrewWordRow';
import { Voice } from '@models/Voice';

@Pipe({
  name: 'voiceInEnglish'
})
export class VoiceInEnglishPipe implements PipeTransform {

  transform(v: Voice): unknown {
    if (v == 'active' || v == 'passive' || v == 'middle') {
      return v;
    } else {
      return OTVerbStemToEnglish(v);
    }
  }

}
